<div class="flex-1 bg-white rounded shadow-xl rounded-xl" [class]="cssClass()">
  <div class="p-6 flex flex-col h-full">
    <div class="mb-8">
      <div class="flex justify-between items-center mb-8">
        <span class="text-2xl font-bold text-primary">{{ chartCase() | translate: chartCaseParams() }}</span>
        <p-select
          [options]="translatedOptions"
          optionLabel="label"
          optionValue="value"
          [placeholder]="translatedOptions.length ? translatedOptions[0].label : ''"
          (onChange)="onFilterChange($event)"
          class="w-full md:w-56"
        />
      </div>
     @if (showSearch) {
    <div class="mb-4 w-full flex gap-2 justify-end">
          <input
            pInputText
            type="text"
            [placeholder]="'DASHBOARD.BROKER_SEARCH_PLACEHOLDER' | translate"
            class="border px-3 py-2 rounded w-56"
            (input)="onBrokerSearch($event)"
          />
          <p-button
          [label]="'SEARCH' | translate"
        icon="pi pi-search"
        styleClass="p-button-primary rounded-sm w-24"
        (onClick)="onBrokerSearchSubmit()"
      ></p-button>
      </div>
      }
      <hr class="border-gray-300" />
    </div>

    @if(!chartReady()){
    <div class="w-full relative">
      <div class="bg-white rounded rounded-xl h-[400px]">
        <chl-loader
          class="!absolute !top-1/2 !left-1/2 -translate-x-1/2 -translate-y-1/2"
        />
      </div>
    </div>
    }@else {

    <!-- end::Header-->

    <!-- begin::Body-->
    <div class="card-body">
      <!-- begin::Chart-->
      <div #chartRef [style.height]="'100%'">
        @if (data().length > 0 ) {
        <apx-chart
          [series]="chartOptions.series!"
          [chart]="chartOptions.chart!"
          [dataLabels]="chartOptions.dataLabels!"
          [plotOptions]="chartOptions.plotOptions!"
          [yaxis]="chartOptions.yaxis!"
          [xaxis]="chartOptions.xaxis!"
          [subtitle]="chartOptions.subtitle!"
          [colors]="chartOptions.colors!"
          [states]="chartOptions.states!"
          [title]="chartOptions.title!"
          [tooltip]="chartOptions.tooltip!"
          [labels]="chartOptions.labels"
          [legend]="chartOptions.legend"
        ></apx-chart>
         } @else {
            <div class="flex items-center justify-center h-[300px]">
              <span class="text-black-500 text-lg font-medium">{{"REPORTS.NO_DATA_FOUND" | translate}}</span>
            </div>
          }
      </div>
      <!-- end::Chart-->
    </div>
    }
  </div>
</div>
